module.exports = __webpack_public_path__ + "img/logo.6bde7da4.png";